import { Environment } from '@src/environment';
import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths } from '@src/paths.ts';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys.ts';
import authenticationService from '@src/api/services/AuthenticationService.ts';
import { shouldRedirectToLogin } from '@src/utils/errorHandling/loginRedirect.ts';

export const rootLoader: LoaderFunction = async ({ request }) => {
  let user;
  try {
    user = await authenticationService.getCurrentUser();
    if (user.isVerified) {
      return user;
    }
  } catch {
    // Just catch the error and redirect to login/register
  }

  const requestUrl = new URL(decodeURIComponent(request.url));
  const isOrganizationInvite = /^\/organizations\/[^/]+\/accept$/.test(
    requestUrl.pathname,
  );
  const hasToken = requestUrl.searchParams.has(SearchParamKeys.TOKEN);
  const goToLogin = requestUrl.searchParams.get('login') === '1';
  const path = !user
    ? isOrganizationInvite && hasToken && !goToLogin
      ? Paths.REGISTER
      : Paths.LOGIN
    : Paths.REGISTER + Paths.VERIFY_MAIL;

  const searchParams = new URLSearchParams();
  if (!!user?.isVerified || shouldRedirectToLogin(requestUrl)) {
    searchParams.append(
      SearchParamKeys.LOGIN_REDIRECT_URL,
      requestUrl.toString().replace(Environment.APP_URL, ''),
    );
  }
  if (hasToken) {
    searchParams.append(
      SearchParamKeys.TOKEN,
      requestUrl.searchParams.get(SearchParamKeys.TOKEN)!,
    );
  }
  const organizationId = requestUrl.pathname.match(
    /\/organizations\/([^/]+).*/,
  )?.[1];
  if (organizationId) {
    searchParams.append(SearchParamKeys.ORG_ID, organizationId);
  }
  return redirect(`${path}?${searchParams.toString()}`);
};
